// import $ from 'jquery';
import React from 'react';
import Field from 'components/fields/Field';
import { isLength } from 'validator';
// import PropTypes from 'prop-types';

class FieldPassword extends Field {
    constructor(props) {
        super(props);
    }
    // format(value) {
    // }
    validate() {
        const { value, min = 8 } = this.props;
        return super.validate() && isLength(value, { min: min });
    }
    render() {
        return (
            <label
                className={this.handleClasses()}
                data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
            >
                {super.renderLabel()}
                {super.renderAutoresize()}
                <input
                    className='field__input'
                    ref={(r) => (this.input = r)}
                    {...super.generateProps()}
                    type='password'
                />
                {super.renderError()}
                {super.renderLoading()}
            </label>
        );
    }
}

export default FieldPassword;
